import sanitizeHtml from '@utils/sanitizeHtml';
import Heading from '@components/Heading/Heading';
import ReturnsOrderLookupForm from '@features/returns/components/ReturnsOrderLookupForm/ReturnsOrderLookupForm';
import { getReturnsFrameDescription, getReturnsHeaderTitle, TReturnsContent } from '@features/returns/utils/extractCmsBlocks';
import { TUserOrderType } from '@features/userPanel/typescript';
import { useTranslation } from 'next-i18next';
import styles from '@features/returns/components/ReturnsLandingSection/ReturnsLandingSection.styles';
type PropsType = {
  headerContent?: TReturnsContent | null;
  onOrderFound: (order: TUserOrderType) => void;
};
const ReturnsLandingSection = ({
  headerContent,
  onOrderFound
}: PropsType) => {
  const {
    t
  } = useTranslation('user');
  const title = getReturnsHeaderTitle(headerContent) || t('returnsPage.landing.title');
  const frameDescription = getReturnsFrameDescription(headerContent);
  const descriptionHtml = frameDescription ? sanitizeHtml(frameDescription) : {
    __html: t('returnsPage.landing.description')
  };
  return <section sx={styles.section}>
      <div sx={styles.container}>
        <div sx={styles.infoColumn}>
          <Heading h={1} display={4} align="left" addSx={styles.title}>
            {title}
          </Heading>
          <div sx={styles.description} dangerouslySetInnerHTML={descriptionHtml} />
        </div>
        <ReturnsOrderLookupForm onOrderFound={onOrderFound} />
      </div>
    </section>;
};
export default ReturnsLandingSection;